import CircleSpinnerLoader from "@/app/components/ui/Reusable/LoaderComponent/CircleSpinnerLoader";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { Fragment, useEffect, useRef, useState } from "react";

type Props = {
  removeSnapmintPaymentMethod?: (value: any) => void;
  cancelPaymentInProgress: boolean;
  order_status;
};

const SnapmintPaymentCancelModal: React.FC<Props> = ({
  removeSnapmintPaymentMethod,
  cancelPaymentInProgress,
  order_status,
}) => {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (order_status === "cancel") {
      setOpen(false);
    }
  }, [order_status]);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-white py-2 px-4 rounded-md bg-red-400 text-xs w-full font-semibold"
      >
        Cancel Payment
      </button>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg text-left  overflow-visible  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-2xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
                  <div className="flex justify-between items-center mt-2">
                    <h2 className="text-base font-semibold">
                      {" "}
                      Are you sure you want to cancel the Snapmint EMI payment?
                    </h2>
                    <XMarkIcon className="w-5 h-5 cursor-pointer" onClick={() => setOpen(false)} />
                  </div>

                  <div className="flex justify-end gap-4 mt-12">
                    <button
                      className="rounded-md bg-gray-400 font-bold px-10 py-2 text-sm text-white "
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      No
                    </button>
                    <button
                      className="rounded-md bg-[#193A6A] font-bold px-10 py-2 text-sm text-white "
                      onClick={(e) => {
                        removeSnapmintPaymentMethod(e);
                      }}
                    >
                      {cancelPaymentInProgress ? (
                        <div className="">
                          {" "}
                          <CircleSpinnerLoader h="20" w="20" />
                        </div>
                      ) : (
                        "Yes"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default SnapmintPaymentCancelModal;
